import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Profile } from '../interfaces/profile.iterface';
import { OAuthService } from 'angular-oauth2-oidc';

export interface ResetPassword {
  password: string;
  newPassword: string;
}
@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private oauthService: OAuthService = inject(OAuthService);
  private profileSignal = signal<any>(null);

  constructor(private http: HttpClient) { }

  // ToDo: interfaces instead of any
  getUserProfile(): Observable<any> {
    const userId = this.userId;
    // const userName = 'carolina3.demo@yopmail.com';
    return this.http.post<Profile>(`${environment.apiURL}/profile/get-profile`, { userId }, { withCredentials: true });
  }

  settIdentityClaims() {
    console.log('userId', this.userId)
    const claims = this.oauthService.getIdentityClaims();
    this.setUserProfile = claims;
  }

  set setUserProfile(profile: any) {
    this.profileSignal.set(profile);
  }

  get getProfile() {
    return this.profileSignal();
  }

  get userId() {
    return localStorage.getItem('user_id');
  }

  updateAccountPswd(payload: any): Observable<any> {
    return this.http.post(`${environment.apiURL}/profile/update-password`, payload);
  }

  removeMFA(payload: any): Observable<any> {
    return this.http.post(`${environment.apiURL}/profile/remove-MFA`, payload);
  }

  // ToDo: interfaces instead of any
  updateProfile(profile: any): Observable<any> {
    const userId = this.userId;
    const profilePayload = {
      userId,
      userName: profile.userName,
      firstName: profile.givenName,
      lastName: profile.sn,
      email: profile.mail,
      mobilePhone: profile.telephoneNumber,
      webauthnDeviceProfiles: profile.webauthnDeviceProfiles,
      oathDeviceProfiles: profile.oathDeviceProfiles
    }
    return this.http.post(`${environment.apiURL}/profile/update-profile`, profilePayload);
  }

  updateDevice(device: any): Observable<any> {
    const userId = this.userId;
    delete device.origin;
    delete device.deviceType;
    const profilePayload = {
      userId,
      oathDeviceProfiles: device
    }
    return this.http.post(`${environment.apiURL}/profile/update-profile`, profilePayload);
  }

  addMAPDevice(payload: any = {}) {
    return this.http.post(`${environment.apiURL}/profile/add-MFA`, payload);
  }

  addPasskeyDevice(payload: any): Observable<any> {
    return this.http.post(`${environment.apiURL}/profile/add-passkey`, payload);
  }

  validateSSOToken() {
    return this.http.post(`${environment.apiURL}/profile/validate`, {});
  }

  getAvailableApps() {
    const userId = this.userId;
    return this.http.get(`${environment.apiURL}/profile/available-apps/${userId}`);
  }

}
